import Vue from '../vue/common/vue-common';
import FeaturedProducts from '../vue/components/product/FeaturedProducts';
import locale from '../vue/i18n/locale';
import general from '../vue/i18n/general';

const elements = cr$.byClass('featured-products-vue');

requestIdleCallback(() =>
    elements.each(
        (el) =>
            new Vue({
                el,
                i18n: locale(general()),
                components: { FeaturedProducts },
            })
    )
);
